/**
 * 案件・承認・確定（F4）のルート定義。案件から見た業務フローのルートは `flow.ts` が持つ。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 案件の一覧・承認一覧・案件の変更一覧・案件の差分のルートを定義する。
 * @graph-connects none
 */
import { createRoute } from '@tanstack/react-router';
import { ApprovalsPage } from '../ApprovalsPage.js';
import { PjDiffRoutePage, PjLanesRoutePage } from '../receivers/pj.js';
import { PjsPage } from '../PjsPage.js';
import { APPROVALS_ROUTE, PJS_ROUTE, PJ_DIFF_ROUTE, PJ_FIELD_DIFF_ROUTE } from '../route-paths.js';
import { rootRoute } from './root.js';

/** @graph-connects none */
export const pjsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: PJS_ROUTE,
  component: PjsPage,
});
/**
 * 承認一覧。PJ を検索条件で受けない（全 PJ を横断する画面なので、PJ を適用した姿ではない）。
 * @graph-connects none
 */
export const approvalsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: APPROVALS_ROUTE,
  component: ApprovalsPage,
});
/**
 * ④PJ の変更一覧。案件をパスの親に置く。
 *
 * 検索条件で案件を受けない（`validateSearch` を張らない）。案件はパスに載っているので、
 * 検索条件でも受けると「どちらの案件を見ているか」の出どころが 2 つになる。
 * @graph-connects none
 */
export const pjDiffRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: PJ_DIFF_ROUTE,
  component: PjLanesRoutePage,
});

/**
 * PJ の差分。変更一覧と同じく案件をパスの親に置き、検索条件で案件を受けない。
 * @graph-connects none
 */
export const pjFieldDiffRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: PJ_FIELD_DIFF_ROUTE,
  component: PjDiffRoutePage,
});

/** 案件・承認のルート。ルート木（`app.tsx`）はこれを並べる。 @graph-connects none */
export const pjRoutes = [pjsRoute, approvalsRoute, pjDiffRoute, pjFieldDiffRoute] as const;
